module.exports = __webpack_public_path__ + "pc-top-assets/img/asuraku.6eb4b37d.gif";